import { createFileRoute } from "@tanstack/react-router";

import ThemePlayground from "@/components/ThemePlayground";

export const Route = createFileRoute("/theme")({
  component: ThemePlayground,
});
